<mat-form-field subscriptSizing="dynamic">
    @if (ngControl?.control) {
        <mat-select
            [panelClass]="'select-panel ' + type"
            [formControl]="$any(ngControl!.control)"
            [errorStateMatcher]="errorMatcher"
            [placeholder]="placeholder"
            [attr.data-uiid]="dataUiid"
            hideSingleSelectionIndicator="true"
            (selectionChange)="onselectionChanged($event)"
        >
            @if (hasColorBadge) {
                <mat-select-trigger class="select-trigger">
                    <span
                        class="color-badge"
                        [attr.data-uiid]="dataUiid + '-trigger'"
                        [style.backgroundColor]="selectedOption?.color"
                    ></span
                    ><span class="select-trigger-text">{{
                        selectedOption?.name
                    }}</span></mat-select-trigger
                >
            }

            @if (showNone) {
                <mat-option>None</mat-option>
            }
            @for (option of options; track option) {
                <mat-option
                    [value]="option.id"
                    [attr.data-uiid]="dataUiid + '-' + option.id"
                    [class.hidden]="useVisibility && !option?.isVisible"
                >
                    @if (hasColorBadge) {
                        <span class="color-badge" [style.backgroundColor]="option.color"></span>
                    }
                    {{ option.name }}</mat-option
                >
            }
        </mat-select>
    } @else {
        <mat-select
            [panelClass]="'select-panel ' + type"
            [(value)]="selected"
            [disabled]="disabled"
            [attr.data-uiid]="dataUiid"
            [placeholder]="placeholder"
            hideSingleSelectionIndicator="true"
            (selectionChange)="onselectionChanged($event)"
        >
            @if (hasColorBadge) {
                <mat-select-trigger class="select-trigger">
                    <span class="color-badge" [style.backgroundColor]="selectedOption?.color"></span
                    ><span class="select-trigger-text">{{
                        selectedOption?.name
                    }}</span></mat-select-trigger
                >
            }

            @if (showNone) {
                <mat-option>None</mat-option>
            }
            @for (option of options; track option) {
                <mat-option [value]="option.id" [attr.data-uiid]="dataUiid + '-' + option.id">
                    @if (hasColorBadge) {
                        <span class="color-badge" [style.backgroundColor]="option.color"> </span>
                    }
                    {{ option.name }}</mat-option
                >
            }
        </mat-select>
    }

    @if (!disabled) {
        <mat-icon matSuffix>expand_more</mat-icon>
    }

    @for (error of ngControl?.control?.errors | errorMessages; track error) {
        <mat-error>{{ error }}</mat-error>
    }
</mat-form-field>
